// Login.js
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const Login = ({ onLogin }) => {
  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
    <h2>Please log in with your Ori Google account</h2>
    <div style={{ display: 'inline-block', minWidth: '200px', maxWidth: '300px' }}>
        <GoogleLogin
        onSuccess={credentialResponse => {
            const idToken = credentialResponse.credential;
            localStorage.setItem('google_id_token', idToken);
            onLogin();
        }}
        onError={() => {
            console.log('Login Failed');
        }}
        />
    </div>
    </div>
  );
};

export default Login;